import React, { useEffect, useState } from "react";
import { IconField } from "primereact/iconfield";
import { InputText } from "primereact/inputtext";
import { InputIcon } from "primereact/inputicon";
import { useLocation, useNavigate } from "react-router-dom";
import { getSelectedTabListView, getStoreLocalData, getUserData, setSelectedTabListView } from "../../utils/localStorage";
import { getDashboardPaymentCollection } from "../../services/PaymentCollection/DashboardPaymentCollection";
import { DataView } from "primereact/dataview";
import { formatDate, formatDateNew, localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";
import { Accordion, AccordionTab } from "primereact/accordion";
import SchedularModal from "../SchedularModal";
import StatusFilterModal from "../StatusFilterModal";
import CollectionStatusFilterModal from "./CollectionStatusFilterModal";
import StoreMenu from "../StoreMenu";
import ButtonLink from "../../ButtonLink";
import AdminMenu from "../AdminMenu";
import useDashboardPaymentCollection from "../StoreContext/useDashboardPaymentCollection";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const { innerWidth: width, innerHeight: height } = window;

const DashboardPaymentCollection = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { orderFilterData, source } = location.state || {}; // Fallback to prevent undefined errors

  const { brandProfileData, userProfileRole, storeData } = getUserData();
  let brandId = brandProfileData.id;

  const userRole = userProfileRole;

  const enabledAmountRoundOff =
    userRole === "BY_STORE" ?
      storeData.enabledAmountRoundOff ? 0 : 2
      : brandProfileData?.enabledAmountRoundOff ? 0 : 2

  const [visible, setVisible] = useState(false);

  const { storeLocalData } = getStoreLocalData();

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate()); // subtract 7 days to current date
  const [searchTerm, setSearchTerm] = useState("");

  const {
    selectedSource,
    setSelectedSource,
    schedularDate,
    setSchedularDate
  } = useDashboardPaymentCollection();

  const [tabularView, setTabularView] = useState(false);

  const handleTabListViewChange = async (selectedType) => {
    setTabularView(selectedType);
    await setSelectedTabListView(selectedType);
  };

  const fetchSelectedTabListView = async () => {
    try {
      const selectedInvoiceTypeData = await getSelectedTabListView();
      setTabularView(selectedInvoiceTypeData?.tabListView || "list");
    } catch {
      setTabularView("list");
    }
  };

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));
  const [paymentCollectionData, setPaymentCollectionData] = useState([]);
  const [
    dashboardPaymentCollectionSchedularModalVisible,
    setDashboardPaymentCollectionSchedularModalVisible,
  ] = useState(false);
  // const [schedularDate, setSchedularDate] = useState({});
  const [categorizedPaymentData, setCategorizedPaymentData] = useState({});
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [paymentReceivedByUser, setPaymentReceivedByUser] = useState([]);

  const [paymentCollectionModalVisible, setPaymentCollectionModalVisible] =
    useState(false);
  // const [selectedSource, setSelectedSource] = useState("");

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setSchedularDate(newSchedular);
  };

  const initializeVariable = () => {
    setPaymentCollectionData([]);
  };

  const handleCalendarModal = () => {
    setDashboardPaymentCollectionSchedularModalVisible(true);
  };

  const getPaymentCollectionData = async (data) => {
    try {
      const response = await getDashboardPaymentCollection(brandId, data);
      if (!response.data.error) {
        // Collect unique receivers
        const uniqueReceivers = new Set();
        response.data.forEach((item) => {
          uniqueReceivers.add(item.payment.receiver);
        });

        // Convert Set to Array if needed
        const uniqueReceiversArray = Array.from(uniqueReceivers);

        const uniqueDataMap = new Map();
        uniqueReceiversArray.forEach((item) => {
          uniqueDataMap.set(item.id, item);
        });

        // Convert the Map back to an array
        const uniqueDataArray = Array.from(uniqueDataMap.values());
        setPaymentReceivedByUser(uniqueDataArray);

        const paymentModes = {};
        response.data.forEach((item) => {
          const mode = item.payment.paymentMode;
          if (!paymentModes[mode]) {
            paymentModes[mode] = [];
          }
          paymentModes[mode].push(item);
        });
        setCategorizedPaymentData(paymentModes);
        setPaymentCollectionData(response.data);
      }
    } catch (error) {
      console.error("Error fetching payment collection data", error);
    }
  };

  const getPaymentCollectionDataWithOrderSource = async (
    data,
    selectedSource
  ) => {
    try {
      const response = await getDashboardPaymentCollection(brandId, data);
      if (!response.data.error) {
        const filteredData = response.data.filter(
          (item) =>
            selectedSource.length === 0 ||
            selectedSource.includes(item.payment.receiver.id)
        );
        const paymentModes = {};
        filteredData.forEach((item) => {
          const mode = item.payment.paymentMode;
          if (!paymentModes[mode]) {
            paymentModes[mode] = [];
          }
          paymentModes[mode].push(item);
        });
        setCategorizedPaymentData(paymentModes);
        setPaymentCollectionData(filteredData);
      }
    } catch (error) {
      console.error("Error fetching payment collection data", error);
    }
  };

  useEffect(() => {
    const data = {
      startDate:
        localeDateStartDate(new Date(schedularDate.startDate)) || localeDateStartDate(new Date(new Date(orderFilterData?.startDate))),
      endDate: localeDateEndDate(new Date(schedularDate.endDate)) || localeDateEndDate(new Date(new Date(orderFilterData?.endDate))),
      storeIds: orderFilterData.storeIds,
      statusIn: orderFilterData.statusIn,
      orderSourceIn: orderFilterData.orderSourceIn,
      paymentSourceIn: orderFilterData.paymentSourceIn,
    };
    getPaymentCollectionDataWithOrderSource(data, selectedSource);
  }, [selectedSource]);

  useEffect(() => {
    const data = {
      startDate:
        localeDateStartDate(new Date(schedularDate.startDate)) || localeDateStartDate(new Date(new Date(orderFilterData?.startDate))),
      endDate: localeDateEndDate(new Date(schedularDate.endDate)) || localeDateEndDate(new Date(new Date(orderFilterData?.endDate))),
      storeIds: orderFilterData.storeIds,
      statusIn: orderFilterData.statusIn,
      orderSourceIn: orderFilterData.orderSourceIn,
      paymentSourceIn: orderFilterData.paymentSourceIn,
    };
    getPaymentCollectionData(data);
    fetchSelectedTabListView();
  }, [orderFilterData, schedularDate]);

  const filterOrderInfoList = () => {
    return paymentCollectionData.filter((item) => {
      const orderNo = item.order.orderNo?.toLowerCase();
      const customerMobile = item.order.customerMobile?.toLowerCase();
      const customerName = item.order.customerName?.toLowerCase();
      const invoiceNo = item.order.invoiceNo?.toLowerCase();
      const matchesSearchTerm = orderNo?.includes(searchTerm.toLowerCase());
      const matchesSearchTermCustomerMobile = customerMobile?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermCustomerName = customerName?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermInvoiceNo = invoiceNo?.includes(
        searchTerm.toLowerCase()
      );
      return (
        matchesSearchTerm ||
        matchesSearchTermCustomerMobile ||
        matchesSearchTermCustomerName ||
        matchesSearchTermInvoiceNo
      );
    });
  };

  const filteredOrderInfoData = filterOrderInfoList();

  const receiveDataFromPaymentCollectionModal = (selectedSource) => {
    setSelectedSource(selectedSource);
  };

  const handlePaymentModePress = (mode) => {
    setSelectedPaymentMode(mode);
  };
  const calculateTotalCollection = (mode) => {
    return categorizedPaymentData[mode].reduce(
      (total, item) => total + item.payment.amount,
      0
    );
  };

  const calculateTotalDataCollection = () => {
    return paymentCollectionData.reduce(
      (total, item) => total + item.payment.amount,
      0
    );
  };

  const renderPaymentModeButtons = () => {
    return Object.keys(categorizedPaymentData).map((mode) => (
      <div
        key={mode}
        // style={[
        //     styles.paymentModeButton,
        //     selectedPaymentMode === mode && styles.selectedPaymentModeButton,
        //   ]}
        style={{
          backgroundColor: selectedPaymentMode === mode ? "#2B70D7" : "#1752AA",
        }}
        className="px-3 py-2 border-round-md cursor-pointer"
        onClick={() => handlePaymentModePress(mode)}
      >
        <p className="text-white text-xl font-bold uppercase">
          {mode.replace(/_/g, " ")} ({storeLocalData?.currencySymbol} {Number(calculateTotalCollection(mode))?.toFixed(enabledAmountRoundOff)})
        </p>
      </div>
    ));
  };

  const itemTemplate = (order, index) => {
    const OrderStatusColors = {
      ROLE_STORE: "#F2BB66",
      ROLE_RIDER: "#808000",
      DEFAULT: "#F5C43A",
    };

    const orderStatusColor =
      OrderStatusColors[order.payment.receiver.role] ||
      OrderStatusColors.DEFAULT;
    const formattedDate = formatDate(order.payment.date);
    return (
      <Accordion>
        <AccordionTab
          key={index}
          style={{
            "--backgroundColor-AccordionTab": orderStatusColor,
          }}
          header={`${order.order.invoiceNo} | ${formattedDate} `}
        >
          <div className="cursor-pointer">
            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Invoice No. :
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.order.invoiceNo}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Paid Amount :
                </p>
                <p className="text-lg font-bold capitalize">
                  {storeLocalData?.currencySymbol} {Number(order.payment.amount)?.toFixed(enabledAmountRoundOff)}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Customer Name:
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.order.customerName}
                </p>
              </div>
            </div>
            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Customer Mobile :
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.order.customerMobile}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Payment Mode :
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.payment.paymentMode.replace(/_/g, " ")} {order?.payment?.paymentRefNo && "|" + order?.payment?.paymentRefNo}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Payment Received By :
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.payment.receiver.firstName +
                    order.payment.receiver.lastName}
                </p>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    );
  };

  const listTemplate = (items) => {
    if (!items || items.length === 0) return null;

    let list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div>{list}</div>;
  };

  const amountBodyTemplate = (rowData) => {
    return (
      <div
        className="cursor-pointer"
      >
        <p >
          {storeLocalData?.currencySymbol} {Number(rowData.payment.amount)?.toFixed(enabledAmountRoundOff)}
        </p>
      </div>
    );
  };

  const paymentModeBodyTemplate = (rowData) => {
    return (
      <div
        className="cursor-pointer"
      >
        <p >
          {rowData.payment.paymentMode.replace(/_/g, " ")} {rowData?.payment?.paymentRefNo && "|" + rowData?.payment?.paymentRefNo}
        </p>
      </div>
    );
  };

  const receiverBodyTemplate = (rowData) => {
    return (
      <div
        className="cursor-pointer"
      >
        <p >
          {rowData.payment.receiver.firstName +
            rowData.payment.receiver.lastName}
        </p>
      </div>
    );
  };

  const RenderTabView = () => {
    return (
      <DataTable
        showGridlines
        value={selectedPaymentMode
          ? categorizedPaymentData[selectedPaymentMode]
          : filteredOrderInfoData}
        // header={header}
        paginator
        rows={50}
        rowsPerPageOptions={[50, 75, 100]}
        tableStyle={{ minWidth: "50rem" }}
        stripedRows
        scrollable
        scrollHeight={height - 240}
      >
        <Column
          field="createdDate"
          header="Date"
          style={{
            width: "40px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => formatDateNew(rowData?.payment.date)}
        />

        <Column
          field="invoiceNo"
          header="Invoice No"
          style={{
            width: "40px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => rowData.order.invoiceNo}
        />

        <Column
          field="customerName"
          header="Customer Name"
          style={{
            width: "50px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => rowData.order.customerName}

        />

        <Column
          field="customerMobile"
          header="Customer Mobile"
          style={{
            width: "40px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => rowData.order.customerMobile}
        />

        <Column
          field="Amount"
          header="Paid Amount"
          style={{
            width: "40px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={amountBodyTemplate}
        ></Column>

        <Column
          field="PaymentMode"
          header="Payment Mode"
          style={{
            width: "40px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={paymentModeBodyTemplate}
        ></Column>

        <Column
          field="Receiver"
          header="Payment Received By"
          style={{
            width: "40px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={receiverBodyTemplate}
        ></Column>
      </DataTable>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate('/full-dashboard')}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Payment Collection
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => {
              tabularView !== "tab"
                ? handleTabListViewChange("tab")
                : handleTabListViewChange("list");
            }}
          >
            <div
              className="px-3 py-1 cursor-pointer"
              style={{
                backgroundColor: "#55BD5A",
                borderRadius: 5,
                marginRight: 20,
              }}
            >
              <p className=" text-lg text-white font-medium capitalize">
                {tabularView !== "tab" ? "Tab View" : "List View"}
              </p>
            </div>
          </div>

          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: height < 600 ? 25 : 30 }}
            />
          </div>
          <div
            onClick={() => setPaymentCollectionModalVisible(true)}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: height < 600 ? 25 : 30 }}
            />
          </div>
          {filteredOrderInfoData.length > 0 && (
            <div
              className="mx-2 cursor-pointer"
              onClick={() => {
                navigate("/Dashboard-payment-collection-receipt", {
                  state: {
                    paymentCollectionData: paymentCollectionData,
                    orderFilterData: orderFilterData,
                    // customerData: customerData,
                    // storeCustomerId: storeCustomerId,
                    // paymentDetails: item,
                  },
                });
              }}
            >
              <img
                src={"Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png"}
                style={{
                  width: 30,
                  height: 30,
                }}
              />
            </div>
          )}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="mx-4 my-2">
        <div className="my-3 mx-1 flex flex-1">
          <div className="flex-1">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"> </InputIcon>
              <InputText
                placeholder={"Search Order"}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
              />
            </IconField>
          </div>
        </div>

        <div
          className="flex gap-3 mb-3 pb-1 new-scroll-bar"
          style={{
            overflowX: "auto",
            whiteSpace: "nowrap",
          }}
        >
          {filteredOrderInfoData.length > 0 && (
            <div
              style={{ backgroundColor: "#2B70D7" }}
              className="px-3 py-2 border-round-md cursor-pointer"
              onClick={() => setSelectedPaymentMode("")}
            >
              <p className="text-white text-xl font-bold uppercase">
                All ({storeLocalData?.currencySymbol} {Number(calculateTotalDataCollection())?.toFixed(enabledAmountRoundOff)})
              </p>
            </div>
          )}

          {renderPaymentModeButtons()}
        </div>

        {filteredOrderInfoData.length > 0 ? (

          <div>
            <div>
              {tabularView === "tab" && (
                <div
                  className="scroll-bar mb-2"
                >
                  <div className="report-table">
                    <div className="tab-view-table">{RenderTabView()}</div>
                  </div>
                </div>
              )}
            </div>
            <div style={{ display: tabularView === "tab" ? "none" : "" }}>
              <DataView
                value={
                  selectedPaymentMode
                    ? categorizedPaymentData[selectedPaymentMode]
                    : filteredOrderInfoData
                }
                listTemplate={listTemplate}
                paginator
                rows={10}
                style={{ maxHeight: height - 180, overflowY: 'auto' }}
              />
            </div>
          </div>



        ) : filteredOrderInfoData.length === 0 ? (
          <div>
            <p className="text-2xl font-semibold text-center">No Data Found</p>
          </div>
        ) : (
          <div>
            <p className="text-2xl font-semibold text-center">
              Payment Collection is Loading...
            </p>
          </div>
        )}
      </div>

      <SchedularModal
        setSchedularModalVisible={
          setDashboardPaymentCollectionSchedularModalVisible
        }
        schedularModalVisible={dashboardPaymentCollectionSchedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
        typeOfOrder={null}
      />
      <CollectionStatusFilterModal
        setStatusFilterModalVisible={setPaymentCollectionModalVisible}
        statusFilterModalVisible={paymentCollectionModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromPaymentCollectionModal}
        paymentReceivedByUser={paymentReceivedByUser}
      />

      {userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER" || userRole === "BY_FRANCHISE_ADMIN" ? (
        <AdminMenu setVisible={setVisible} visible={visible} />
      ) : (
        <>
          <StoreMenu setVisible={setVisible} visible={visible} />
          <ButtonLink />
        </>
      )}
    </div>
  );
};

export default DashboardPaymentCollection;
